module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_1@2x.b95774e3.png";